export { default as arrowRight } from './arrow-right.svg'
export { default as arrowTopRight } from './arrow-top-right.svg'
export { default as back } from './back.svg'
export { default as backToTop } from './back-to-top.svg'
export { default as bigTag } from './bigTag.svg'
export { default as bigArrowRight } from './big-arrow-right.svg'
export { default as burger } from './burger.svg'
export { default as check } from './check.svg'
export { default as closeSmall } from './close-small.svg'
export { default as chevronDown } from './chevron-down.svg'
export { default as chevronLeft } from './chevron-left.svg'
export { default as chevronRight } from './chevron-right.svg'
export { default as download } from './download.svg'
export { default as logoFooter } from './logo-footer.svg'
export { default as logoHeader } from './logo-header.svg'
export { default as minus } from './minus.svg'
export { default as playerCaptionsOff } from './player-captions-off.svg'
export { default as playerCaptionsOn } from './player-captions-on.svg'
export { default as playerMaximize } from './player-maximize.svg'
export { default as playerMinimize } from './player-minimize.svg'
export { default as playerPause } from './player-pause.svg'
export { default as playerPlay } from './player-play.svg'
export { default as playerSkipForward } from './player-skip-forward.svg'
export { default as playerTranscript } from './player-transcript.svg'
export { default as playerVolume0 } from './player-volume-0.svg'
export { default as playerVolume1 } from './player-volume-1.svg'
export { default as playerVolume2 } from './player-volume-2.svg'
export { default as playerVolumeMute } from './player-volume-mute.svg'
export { default as plus } from './plus.svg'
export { default as quote } from './quote.svg'
export { default as search } from './search.svg'
export { default as roundCheck } from './round-check.svg'
export { default as roundCheckActive } from './round-check-active.svg'
export { default as socialsFacebook } from './socials-facebook.svg'
export { default as socialsInstagram } from './socials-instagram.svg'
export { default as socialsLinkedin } from './socials-linkedin.svg'
export { default as socialsTiktok } from './socials-tiktok.svg'
export { default as socialsTwitter } from './socials-twitter.svg'
export { default as socialsYoutube } from './socials-youtube.svg'
export { default as timer } from './timer.svg'
export { default as checkboxDefault } from './checkbox-default.svg'
export { default as checkboxFilled } from './checkbox-filled.svg'
